import { useMemo, useState } from "react";
import { pickQuagganEmoji } from "../utils/quagganEmojiPool";

export default function QuagganEmoji({ type, seed, inline = false, size = 96, className = "", style }) {
  const [fallbackSeed] = useState(() => `quag-${Math.random().toString(36).slice(2)}`);

  const src = useMemo(
    () => pickQuagganEmoji({ type: type || "failure", seed: seed ?? fallbackSeed }),
    [type, seed, fallbackSeed],
  );

  const baseStyle = {
    display: "block",
    margin: inline ? 0 : "8px auto 0",
    height: size,
    width: "auto",
    ...style,
  };

  return (
    <img
      src={src}
      alt=""
      className={className}
      style={baseStyle}
    />
  );
}
